import type { UiAuthUser, UiUser } from '../../schemas/users.schema';
import type { Maybe } from '../../types/maybe.types';

/**
 * Merges a PATCH /v2/auth/me result into the in-memory auth user. The PATCH
 * response is reloaded without the organizationUsers/roles includes, and
 * mapUserFromApi coerces those absent relations into `[]`/undefined — so a
 * whole-object spread would wipe membership/authorization state and get the
 * user bounced out of their own organization by OrganizationGuard. Copy only
 * the profile fields the endpoint can actually change.
 */
export function applyProfileUpdate(
  prev: Maybe<UiAuthUser>,
  update: Maybe<UiUser>,
): Maybe<UiAuthUser> {
  if (!prev || !update) return prev;
  return {
    ...prev,
    address: update.address,
    contact: update.contact,
    fitnessProfile: update.fitnessProfile,
    name: update.name,
    username: update.username ?? prev.username,
    settings: update.settings ?? prev.settings,
    socialMedia: update.socialMedia,
  };
}
